class SimilarProduct extends HTMLElement {
  constructor() {
    super();
    this.variantChangeHandler = this.variantChangeHandler.bind(this);
    this.cta = this.querySelector("dialog-toggle button");
    this.sizeLabel = this.querySelector('[data-target="size"]');

    const similarItemsContainer = this.querySelector("#pdp-similar-products");
    const observer = new MutationObserver((mutationsList, observer) => {
      this.triggerVariantChange();
      observer.disconnect();
    });

    const observeConfig = {
      attributes: true,
      childList: true,
    };

    observer.observe(similarItemsContainer, observeConfig);
  }

  triggerVariantChange() {
    setTimeout(() => {
      this.variantChangeHandler();
    }, 200);
  }

  connectedCallback() {
    document.addEventListener("variant-change", this.variantChangeHandler);
  }

  variantChangeHandler(event) {
    const crtEvent = !event && this.lastEvent ? this.lastEvent : event;
    if (event) this.lastEvent = crtEvent;

    const { options, available } = crtEvent.detail || {};
    const { Size: size } = options || {};
    this.cta.classList.add("hidden");

    if (size == null || available) {
      return;
    }

    if (this.sizeLabel) this.sizeLabel.textContent = size;
    let hasMatchingSize = false;

    this.querySelectorAll("[data-sizes]").forEach((item) => {
      const sizes = item
        .getAttribute("data-sizes")
        ?.split(",")
        .map((s) => s.trim());

      if (sizes && sizes.includes(String(size))) {
        item.classList.remove("hidden");
        hasMatchingSize = true;
      } else {
        item.classList.add("hidden");
      }
    });

    if (hasMatchingSize) {
      this.cta.classList.remove("hidden");
    }
  }

  disconnectedCallback() {
    document.removeEventListener("variant-change", this.variantChangeHandler);
  }
}

customElements.define("similar-products", SimilarProduct);
